import EntityDirectoryPage from './EntityDirectoryPage'
import { vendorsApi } from '../../../shared/lib/api'

export default function VendorsPage() {
  return (
    <EntityDirectoryPage
      api={vendorsApi}
      entity={{
        singular: 'Vendor',
        plural: 'Vendors',
        searchPlaceholder: 'Search vendors...',
        emailPlaceholder: 'vendor@email.com',
        exampleName: 'Mehta Textiles',
        totalLabel: 'Total Purchases',
        dateLabel: 'Last Purchase',
      }}
    />
  )
}
